module.exports = __webpack_public_path__ + "static/sixth_user_image5-fe69ff6c0837d7fc34cbc06f2173c548.jpg";